import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { API_URL } from "../../shared/constant";
import { toast } from "react-toastify";
import Loader from "../../shared/loader";
import axios from "axios";
import moment from "moment";

const Estimate = () => {
    const { id } = useParams();
    const [loading, setLoading] = useState(true);
    const [loginUser, setLoginUser] = useState({
        id: null,
        name: null,
        address: null,
        country_name: null,
        city_name: null,
        state_name: null,
        pincode: null,
        gst_no: null,
    });
    const [invoice, setInvoice] = useState({
        party: {},
        ship: {},
        items: [],
    });

    const a = [
      "",
      "one ",
      "two ",
      "three ",
      "four ",
      "five ",
      "six ",
      "seven ",
      "eight ",
      "nine ",
      "ten ",
      "eleven ",
      "twelve ",
      "thirteen ",
      "fourteen ",
      "fifteen ",
      "sixteen ",
      "seventeen ",
      "eighteen ",
      "nineteen ",
    ];
    const b = [
      "",
      "",
      "twenty",
      "thirty",
      "forty",
      "fifty",
      "sixty",
      "seventy",
      "eighty",
      "ninety",
    ];
  
    const inWords = (num) => {
      num = parseInt(num);
      if ((num = num.toString()).length > 9) return "overflow";
      let n = ("000000000" + num)
        .substr(-9)
        .match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
      if (!n) return;
      var str = "";
      str +=
        n[1] != "0" && n[1] != "00"
          ? (a[Number(n[1])] || b[n[1][0]] + " " + a[n[1][1]]) + "crore "
          : "";
      str +=
        n[2] != "0" && n[2] != "00"
          ? (a[Number(n[2])] || b[n[2][0]] + " " + a[n[2][1]]) + "lakh "
          : "";
      str +=
        n[3] != "0" && n[3] != "00"
          ? (a[Number(n[3])] || b[n[3][0]] + " " + a[n[3][1]]) + "thousand "
          : "";
      str +=
        n[4] != "0" && n[4] != "00"
          ? (a[Number(n[4])] || b[n[4][0]] + " " + a[n[4][1]]) + "hundred "
          : "";
      str +=
        n[5] != "0" && n[5] != "00"
          ? (str != "" ? "and " : "") +
          (a[Number(n[5])] || b[n[5][0]] + " " + a[n[5][1]]) +
          "only "
          : "";
      return str;
    };

    const getEdit = () => {
        axios.post(API_URL.INVOICE_GET, { id: id }).then((res) => {
          if (res.data.status == 1) {
            if (res.data.data.date) {
              res.data.data.date = moment(new Date(res.data.data.date)).format(
                "DD/MM/YYYY"
              );
            }
            if (res.data.data.lr_date) {
              res.data.data.lr_date = moment(
                new Date(res.data.data.lr_date)
              ).format("DD/MM/YYYY");
            }
            setInvoice(res.data.data);
          } else {
            toast.error(res.data.data, { autoClose: 3000 });
          }
          setLoading(false);
        });
    };

    const getUserInfo = () => {
      axios.post(API_URL.LOGIN_USER, {}).then((res) => {
        setLoginUser(res.data.data);
      });
    };

    useEffect(() => {
        if (id) {
          getEdit();
          getUserInfo();
        }
      }, [id]);

    const printEstimate = () => {
        setTimeout(() => {
            window.print();
        }, 300);
    };

    const calculateTotalWeight = () => {
        // Calculate weight based on items - if weight field is not available, 
        // you may need to adjust this based on your product data structure
        return invoice.items?.reduce((total, item) => {
            const weight = parseFloat(item.product?.weight || item.weight || 0) * parseFloat(item.qty || 0);
            return total + weight;
        }, 0) || 0;
    };

    const getTotalItems = () => {
        return invoice.items?.reduce((total, item) => {
            return total + parseFloat(item.qty || 0);
        }, 0) || 0;
    };

    return (
        <>
          <div className="row">
            <div className="col-6 no-print">
              <h1>Estimate</h1>
            </div>
            <div className="col-6 no-print">
              <div className="d-flex align-items-center justify-content-end">
                <button 
                  onClick={printEstimate} 
                  className="btn btn-primary mr-2"
                >
                  Print
                </button>
                <Link to={"/sales/invoices"} className="btn btn-dark">
                  Back
                </Link>
              </div>
            </div>
            <div className="col-md-12">
              {loading && <Loader></Loader>}
              {!loading && (
                <div className="estimate-container" style={{ 
                  backgroundColor: "#fff", 
                  padding: "20px",
                  marginTop: "20px",
                  fontSize: "16px"
                }}>

                  {/* Header */}
                  <div style={{ border: "1px solid #000", padding: "15px", display: "flex", justifyContent: "space-between" }}>
                    <div>
                        <h2 style={{margin: 0, padding: 0, fontSize: "24px", fontWeight: "bold"}}>
                          ESTIMATE
                        </h2>
                        <div style={{ marginTop: "5px" }}>
                          <strong>Date:</strong> {invoice.date || ""}
                          <br />
                          <strong>Estimate:</strong> #{invoice.id}
                        </div>
                    </div>
                    <div>
                      <h2 style={{margin: 0, padding: 0, fontSize: "24px", fontWeight: "bold"}}>
                        {loginUser?.name}
                      </h2>
                      <div><strong>{loginUser?.address}</strong></div>
                      <div><strong>GST No: {loginUser?.gst_no}</strong></div>
                    </div>
                  </div>

                  {/* Main Content */}
                  <div style={{ 
                    display: "flex", 
                    borderLeft: "1px solid #000",
                    borderRight: "1px solid #000",
                  }}>
                    {/* Left Column - Consignee Info */}
                    <div style={{ 
                      width: "50%", 
                      paddingLeft: "20px",
                      paddingTop: "15px",
                      paddingBottom: "15px",
                      borderRight: "1px solid #000"
                    }}>
                      <div style={{ marginBottom: "10px" }}>
                        <strong>Name & Address of Consignee</strong>
                      </div>
                      <div style={{ marginBottom: "5px", fontWeight: "bold" }}>
                        {invoice.party?.name || ""}
                      </div>
                      <div style={{ marginBottom: "5px" }}>
                        {invoice.party?.address || ""}
                      </div>
                      {invoice.party?.city_name && (
                        <div style={{ marginBottom: "5px" }}>
                          {invoice.party.city_name}
                          {invoice.party?.state_name && `, ${invoice.party.state_name}`}
                          {invoice.party?.pincode && `, ${invoice.party.pincode}`}
                        </div>
                      )}
                      {invoice.party?.gst_no && (
                        <div style={{ marginTop: "10px" }}>
                          <strong>GST:</strong> {invoice.party.gst_no}
                        </div>
                      )}
                    </div>

                    {/* Right Column - Shipped To & Transport */}
                    <div style={{ 
                      width: "50%", 
                      paddingTop: "15px",
                      paddingBottom: "15px",
                      paddingLeft: "20px"
                    }}>
                      <div style={{ marginBottom: "15px" }}>
                        <div style={{ marginBottom: "10px" }}>
                          <strong>Details of Consignee (Shipped To)</strong>
                        </div>
                        <div style={{ marginBottom: "5px" }}>
                          {invoice.ship_name || invoice.party?.name || ""}
                        </div>
                        <div style={{ marginBottom: "5px" }}>
                          {invoice.ship_address_one || invoice.party?.address || ""}
                        </div>
                        <div style={{ marginBottom: "5px" }}>
                            {invoice?.shipcity?.name ?? invoice.party?.city_name}
                            {invoice.party?.state_name && `, ${invoice.party.state_name}`}
                            {invoice.ship_pincode ?? invoice.party?.pincode ? `, ${invoice.party.pincode}` : ""}
                        </div>
                      </div>

                      <div style={{ marginTop: "15px", borderTop: "1px solid #ccc", paddingTop: "10px" }}>
                        <table style={{ width: "100%" }}>
                          <tbody>
                            <tr>
                              <td style={{ padding: "3px 0", width: "80px" }}>
                                <strong>Transport:</strong>
                              </td>
                              <td style={{ padding: "3px 0" }}>
                                <span className="bill_transport" style={{ textTransform: "capitalize" }}>
                                  {invoice?.transport?.name ?? ""}
                                </span>
                              </td>
                            </tr>
                            <tr>
                              <td style={{ padding: "3px 0", width: "80px" }}>
                                <strong>Vehicle No:</strong>
                              </td>
                              <td style={{ padding: "3px 0", width: "130px" }}>
                                {invoice.vehicle_no || ""}
                              </td>
                              <td style={{ padding: "3px 0", width: "50px" }}>
                                <strong>LR No:</strong>
                              </td>
                              <td style={{ padding: "3px 0" }}>
                                {invoice.lr_no || ""}
                              </td>
                              <td style={{ padding: "3px 0", width: "70px" }}>
                                <strong>LR Date:</strong>
                              </td>
                              <td style={{ padding: "3px 5px", width: "70px" }}>
                                {invoice.lr_date || ""}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  {/* Product Table */}
                  <div>
                    <table style={{ 
                      width: "100%", 
                      borderCollapse: "collapse",
                      border: "1px solid #000"
                    }}>
                      <thead>
                        <tr style={{ backgroundColor: "#f0f0f0" }}>
                          <th style={{ 
                            border: "1px solid #000",
                            padding: "8px",
                            textAlign: "left",
                            width: "50px"
                          }}>
                            #
                          </th>
                          <th style={{ 
                            border: "1px solid #000",
                            padding: "8px",
                            textAlign: "left"
                          }}>
                            Product
                          </th>
                          <th style={{ 
                            border: "1px solid #000",
                            padding: "8px",
                            textAlign: "left",
                            width: "150px"
                          }}>
                            Qty
                          </th>
                          <th style={{ 
                            border: "1px solid #000",
                            padding: "8px",
                            textAlign: "left",
                            width: "150px"
                          }}>
                            Rate
                          </th>
                          <th style={{ 
                            border: "1px solid #000",
                            padding: "8px",
                            textAlign: "left",
                            width: "150px"
                          }}>
                            GST
                          </th>
                          <th style={{ 
                            border: "1px solid #000",
                            padding: "8px",
                            textAlign: "left",
                            width: "150px"
                          }}>
                            Amount
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {invoice.items?.map((item, index) => (
                          <tr key={index}>
                            <td style={{ 
                              border: "1px solid #000",
                              padding: "8px",
                              textAlign: "center"
                            }}>
                              {index + 1}
                            </td>
                            <td style={{ 
                              border: "1px solid #000",
                              padding: "8px"
                            }}>
                              {item.product?.name} {item.subproduct?.name ? ` - ${item.subproduct?.name}` : ""} {item.subproduct?.size?.name ? ` - ${item.subproduct?.size?.name}` : ` - ${item.product?.size?.name}`}
                              {/* {item.product?.name} {item.subproduct?.name ? ` - ${item.subproduct?.name}` : ""} {item.subproduct?.size?.name ? ` - ${item.subproduct?.size?.name}` : ` - ${item.product?.size?.name}`} */}
                            </td>
                            <td style={{ 
                              border: "1px solid #000",
                              padding: "8px"
                            }}>
                              {item.qty} {item.unit || item.product?.unit || "Box"}
                            </td>
                            <td style={{ 
                              border: "1px solid #000",
                              padding: "8px"
                            }}>
                              {item.rate}
                            </td>
                            <td style={{ 
                              border: "1px solid #000",
                              padding: "8px"
                            }}>
                              {item.product?.gst || 0}%
                            </td>
                            <td style={{ 
                              border: "1px solid #000",
                              padding: "8px"
                            }}>
                              {item.amount}
                            </td>
                          </tr>
                        ))}
                        <tr>
                          <td colSpan="2" style={{ textAlign: "left", padding: "8px", border: "1px solid #000" }}></td>
                          <td style={{ textAlign: "left", padding: "8px", border: "1px solid #000" }}>
                            <div>
                                <strong>{getTotalItems()} Items</strong>
                            </div>
                          </td>
                          <td style={{ textAlign: "left", padding: "8px", border: "1px solid #000" }}>
                            <div>
                                <strong>{calculateTotalWeight().toFixed(2)} KG</strong>
                            </div>
                          </td>
                          <td style={{ textAlign: "left", padding: "8px", border: "1px solid #000" }}>
                            <strong>Total</strong>
                          </td>
                          <td style={{ textAlign: "left", padding: "8px", border: "1px solid #000" }}>
                              <strong>{parseFloat(invoice.sub_total).toFixed(2)}</strong>
                          </td>
                        </tr>
                        <tr>
                          <td colSpan="4"></td>
                          <td style={{ textAlign: "left", padding: "8px", border: "1px solid #000" }}>
                          <strong>Tax Amount</strong>
                          </td>
                          <td style={{ textAlign: "left", padding: "8px", border: "1px solid #000" }}>
                            <strong>{parseFloat(invoice.tax_amount).toFixed(2)}</strong>
                          </td>
                        </tr>
                        <tr>
                          <td colSpan="4" style={{ textAlign: "left", padding: "8px", border: "1px solid #000" }}>
                            {inWords(parseFloat(invoice.total_amount))}
                          </td>
                          <td style={{ textAlign: "left", padding: "8px", border: "1px solid #000" }}>
                            <strong>Final Amount</strong>
                          </td>
                          <td style={{ textAlign: "left", padding: "8px", border: "1px solid #000" }}>
                            <strong>{parseFloat(invoice.total_amount).toFixed(2)}</strong>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
          </div>
        </>
      );

};

export default Estimate;